

































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import wxGroupModelEdit from "../tenantsView/wx-message_GroupModelEdit.vue"; //模板群发回复表单
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";

//import App from "@/components/Global/GetAppData"; //缓存接口
import { log } from "util";
import { WXText } from "@/Entity"; //全局常量
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
//import jsonView from "vue-json-views";
@Component({
  components: {
    wxGroupModelEdit,
    jsonView: function(resolve) {
      require(["vue-json-views"], resolve);
    }
  }
})
export default class extends Vue {
  //注入数据 @Provide()
  @Provide()
  private commonMain = true;
  private pagesize = 10; //每页的数据条数
  private pageIndex = 1; // 默认第一页
  private total = 0; //记录总数
  private ModelGroupEdit = true; //父子组件的显示和隐藏
  private ModelGrouptabData: any = [];

  private SearchForm: any = []; //定义查询
  private ModeltabData: any = []; //加载模板数据
  private optionFansList: any = []; //查询出来的粉丝数据
  private showsearchName = "展开";
  private searchdisplay = false;
  private searchTime: any = [];
  private scrollHeight = 500; //当前高度
  private GetAppData: any = []; //取应用号信息
  private loading = false; //加载数据
  private loadingText = "数据正在查询中，请稍后.....";
  private viewImage = false;

  private modelCountShow = false;
  private modelCount = "";

  private picture = {
    url: "",
    height: ""
  };
  //重置查询条件
  async searchReset() {
    this.SearchForm = [];
    this.searchTime = [];
    this.getTextList();
  }
  //搜索接收人
  async remoteMethod(query: string) {
    if (query !== "") {
      let AppAccount = this.GetAppData;
      if (AppAccount) {
        let params: any = {
          Input: [
            {
              Name: "AppFansSelect",
              Value: {
                Aid: AppAccount.Aid,
                NickName: query,
                OpenID: "",
                Sex: -1
              }
            }
          ]
        };
        var res: any = await httpApi.SarchFansList(params);
        //console.log(res);
        if (res.ErrorCode == 0) {
          this.optionFansList = res.output[0].value;
          //console.log(this.optionFansList);
        } else {
          this.$message.error("失败：" + res.ErrorMessage);
        }
      }
    }
  }
  //查看内容
  modelCountBnt(count: any) {
    this.modelCountShow = true;
    try {
      this.modelCount = JSON.parse(count);
    } catch (e) {
      this.modelCount = count;
    }
  }
  //查看图片
  onViewImage(imageUrl: string) {
    console.log(imageUrl);

    if (imageUrl) {
      this.viewImage = true;
      var img_url = imageUrl;
      var img = new Image();
      img.src = img_url;
      this.picture.height = Math.ceil((img.height / img.width) * 570) + "px";
      this.picture.url = imageUrl;
    }
  }
  //加载模板数据
  async ModeltabDataList() {
    var _this = this;
    //console.log(this.GetAppData);
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      //搜索的数据 传参
      let params: any = {
        Input: [
          //分页参数
          {
            Name: "aid",
            Value: AppAccount.Aid
          }
        ]
      };
      //console.log(params);
      var res: any = await httpApi.GetModel(params);
      if (res.ErrorCode == 0) {
        _this.ModeltabData = res.output[0].value;
        // console.log("模板消息", this.ModeltabData);
        // _this.totalItem = _this.ModeltabData.length;
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }
  //加载发送记录
  async getTextList() {
    //console.log(this.searchTime);

    if (this.searchTime == null) this.searchTime = [];
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      this.loading = true;
      //合成搜索条件
      var QueryConditions = [];
      if (AppAccount.Aid) {
        QueryConditions.push({
          FieldName: "AID",
          Mode: "1",
          Values: [AppAccount.Aid]
        });
      }
      if (this.SearchForm.TemplateID) {
        QueryConditions.push({
          FieldName: "TemplateID",
          Mode: "7",
          Values: [this.SearchForm.TemplateID]
        });
      }

      if (this.SearchForm.SendContent) {
        QueryConditions.push({
          FieldName: "SendContent",
          Mode: "7",
          Values: [this.SearchForm.SendContent]
        });
      }

      if (this.searchTime.length == 2) {
        QueryConditions.push({
          FieldName: "SendTime",
          Mode: "9",
          Values: this.searchTime
        });
      }
      // if (this.searchTime.length == 2) {
      //   QueryConditions.push({
      //     FieldName: "SendTime",
      //     Mode: "5",
      //     Values: [this.searchTime[0]]
      //   });
      //   QueryConditions.push({
      //     FieldName: "SendTime",
      //     Mode: "6",
      //     Values: [this.searchTime[1]]
      //   });
      // }
      if (this.SearchForm.Receiver) {
        QueryConditions.push({
          FieldName: "Receiver",
          Mode: "1",
          Values: [this.SearchForm.Receiver]
        });
      }

      if (this.SearchForm.Status) {
        QueryConditions.push({
          FieldName: "Status",
          Mode: "1",
          Values: [this.SearchForm.Status]
        });
      }

      if (this.SearchForm.Remark) {
        QueryConditions.push({
          FieldName: "Remark",
          Mode: "7",
          Values: [this.SearchForm.Remark]
        });
      }

      if (this.SearchForm.FormID) {
        QueryConditions.push({
          FieldName: "SendContent",
          Mode: "7",
          Values: [this.SearchForm.FormID]
        });
      }
      let params: any = {
        Input: [
          {
            Name: "page",
            Value: {
              page: this.pageIndex,
              rows: this.pagesize,
              QueryConditions: QueryConditions
            }
          }
        ]
      };
      // console.log(params);
      // console.log("模板消息发送记录" + JSON.stringify(params));
      var res: any = await httpApi.TemplateMessageList(params);
      this.loading = false;
      if (res.ErrorCode == 0) {
        //console.log("模板消息发送记录" + JSON.stringify(res));
        this.ModelGrouptabData = res.output[0].value;
        this.total = res.output[1].value;
      }
    }
  }
  //显示隐藏更多搜素条件
  showsearch() {
    if (this.showsearchName == "展开") {
      this.showsearchName = "收起";
      this.scrollHeight = this.scrollHeight - 55;
    } else {
      this.showsearchName = "展开";
      this.scrollHeight = this.scrollHeight + 55;
    }
    this.searchdisplay = !this.searchdisplay;
  }
  watch() {
    this.showsearch();
  }
  //格式化时间
  formatDate(row: any, column: any) {
    if (row.SendTime) {
      // var date = new Date(row.UpdaterDate);
      // return FomatDataStr.formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      var date = row.SendTime;
      date = date.replace("T", " ");
      date = date.substring(0, 19);
      return date;
    } else {
      return "";
    }
  }
  //格式化状态
  formatStatus(row: any, column: any) {
    switch (row.Status) {
      case -1:
        return "失败";
        break;
      case 1:
        return "成功";
        break;
      default:
        return "未知";
        break;
    }
  }
  //方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.getTextList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = val;
    this.getTextList();
  }
  private changGroupModelTable() {
    var that = this;
    that.$emit("GroupModelTablechanged", false);
  }
  //新增文本方法
  AddModelEdit() {
    this.ModelGroupEdit = false;
  }
  //初始化
  created() {
    this.scrollHeight = document.body.scrollHeight - 460;
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj: any) => {
      console.log(obj);
      that.GetAppData.Aid = obj.Aid;
      if (obj.typeCode != "TypeCode_002" && obj.typeCode != "TypeCode_007") {
        // that.$message.warning("当前应用号类型不支持编辑菜单功能，请切换类型为微信（服务号订阅号）！");
        that.ModelGrouptabData = [];
        that.total = 0;
        that.ModeltabData = [];
        that.commonMain = false;
      } else {
        that.commonMain = true;
        that.getTextList();
        that.ModeltabDataList();
      }
    });
    this.getTextList();
    this.ModeltabDataList();
  }
}
